import { Box } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";

const ShadowBox = styled(Box)({
  boxShadow: "0px 30px 40px rgba(76, 54, 24, 0.1)",
});

export default ShadowBox;
